<template>
  <div class="about">
    <Header />
    <Aboutus />
    <CategoryFooter />

  </div>
</template>

<script>
import Header from "../common/Header.vue";
import CategoryFooter from "../common/CategoryFooter.vue";
import Aboutus from "../common/Aboutus.vue";

export default {
  name: "aboutus",

  components: {
    Header,
    Aboutus,
    CategoryFooter
  }
};
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// Aboutus.vue